import "../App.css";
import "./styles/about.css";
import stars2 from "../images/stars2.svg";
import cat from "../images/cat.png";
import bear from "../images/Bear.png";
import hoppersleepy from "../images/hoppersleepy.png";
import cloud1 from "../images/cloud1.svg";
import cloud2 from "../images/cloud2.svg";
import { forwardRef } from "react";

function About(props, ref) {
  return (
    <>
      <div
        ref={ref}
        class="about position-relative text-white w-100 display-block p-5"
      >
        <div class="content p-5" style={{ top: "3vw" }}>
          <h1
            className="text-center"
            style={{ fontSize: "4vw", fontWeight: "bold" }}
          >
            ABOUT
          </h1>
          <div className="container fs-xs-5 fs-md-5 fs-lg-5">
            <div className="row pb-5">
              <div className="d-flex justify-content-center">
                <div className="embed-responsive embed-responsive-16by9 w-100">
                  <iframe
                    className="embed-responsive-item"
                    src="https://www.youtube.com/embed/dAzPHIiOgv0"
                    allowfullscreen
                    style={{ width: "100%", height: "550px" }}
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="row pt-5">
              <h1 className="text-center text-uppercase">hybrid environment</h1>
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12 hybrid mb-5 mb-sm-2">
                  <div class="text-center AboutHopperFriends">
                    <img
                      src={bear}
                      class="img-fluid"
                      alt="Hopper Image"
                      style={{ maxWidth: "17vh" }}
                    />
                  </div>
                  <div className="container fill-moon-yellow border-moon-yellow rounded-5 border-5  p-4">
                    <h4>Hybrid</h4>
                    <ul>
                      <li>
                        Hybrid events that combines both in-person and virtual
                        participation.
                      </li>
                      <li>Receive technical assistance from mentors.</li>
                      <li>Mini games will be held throughtout the event</li>
                      <li>Network with sponsors.</li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 inperson mb-5 mb-sm-2">
                  <div class="text-center AboutHopperFriends">
                    <img
                      src={cat}
                      class="img-fluid"
                      alt="Hopper Image"
                      style={{ maxWidth: "20vh" }}
                    />
                  </div>
                  <div className="container border fill-blue rounded-5 border-primary border-5 p-4">
                    <h4>In person</h4>
                    <ul>
                      <li>
                        Held at the Stony Brook University, Alan S. deVries
                        Center
                      </li>
                      <li>
                        Visit the photobooth and take pictures with your team
                        and other participants.
                      </li>
                      <li>
                        Recieve swag such as T-shirts, stickers, and more!
                      </li>
                      <li>
                        Attend workshops and network with other students in
                        person.
                      </li>
                      <li>
                        Catered food and drinks will be provided throughout the
                        event!
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 virtual mb-sm-2">
                  <div class="text-center AboutHopperFriends">
                    <img
                      src={hoppersleepy}
                      class="img-fluid"
                      alt="Hopper Image"
                      style={{ maxWidth: "20vh" }}
                    />
                  </div>
                  <div className="container fill-pink rounded-5 border-5 border-pink  p-4">
                    <h4>Virtual</h4>
                    <ul>
                      <li>Attend virtual events from anywhere.</li>
                      <li>Judging will be held virtually.</li>
                      <li>Resume workshops will be held virtually.</li>
                      <li>
                        Chat with other participants and mentors on Discord
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="clouds">
          <img
            src={cloud1}
            alt="Cloud Image"
            className="position-absolute img-fluid cloud-animation-2"
            style={{
              maxWidth: "10%",
              top: 0,
              left: -25,
              zIndex: -1,
            }}
          />
          <img
            src={cloud2}
            alt="Cloud Image"
            className="position-absolute img-fluid cloud-animation-1"
            style={{
              maxWidth: "15%",
              top: "75%",
              left: "85%",
              opacity: 0.5,
              zIndex: -1,
            }}
          />
        </div>
        <div className="stars">
          <img
            src={stars2}
            alt="Stars"
            className="position-absolute img-fluid"
            style={{
              maxWidth: "100%",
              left: 0,
              top: 0,
              pointerEvents: "none",
            }}
          />

          <div
            className="position-absolute star"
            style={{
              left: 0,
              top: 0,
              zIndex: -1,
            }}
          ></div>

          <div className="position-absolute" style={{ top: 0 }}>
            <div className="stars-1"></div>
            <div className="stars-2"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default forwardRef(About);
